import { URL } from "./constants";

export const fetchFichaTecnica = async (lang) => {
    const response = await fetch(`${URL.urlFichaTecnica}${lang}`);
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }
    return response.json();
  };

  export const fetchFichaTecnicaWBL = async (lang) => {
    const response = await fetch(`${URL.urlFichaTecnicaWBL}${lang}`);
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }
    return response.json();
  };

  export const submitFormData = async (formData) => {
    try {
      const response = await fetch(URL?.urlSubmitForm/* 'http://10.10.16.12:8080/opendata_dev/static/register/request/' */, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      console.log('Response status:', response.status);  // Añadido para verificar el estado de la respuesta
      console.log('Response URL:', response.url);  // Añadido para verificar la URL de la respuesta
      if (!response.ok) {
        
        throw new Error('Network response was not ok');
      }
  
      // Procesar la respuesta si es necesario
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw new Error('Error submitting form data: ' + error.message);
    }
  };